import React, {
  ChangeEvent,
  FC,
  ReactNode,
  useRef,
  KeyboardEvent,
} from "react";
import { useField } from "formik";
import cx from "classnames";
import ToggleSwitch from "../../ToggleSwitch";
import "../../ToggleSwitch/styles.scss";

interface IToggleFormikProps {
  name: string;
  value?: any;
  className?: string;
  label?: ReactNode;
  hint?: ReactNode;
  labelBold?: boolean;
  testId?: string;
  onChange?: (value: boolean) => void;
}

const ToggleFormik: FC<IToggleFormikProps> = ({
  name,
  value,
  className,
  label,
  labelBold,
  hint,
  testId,
  onChange,
}) => {
  const [field, _, helpers] = useField(name);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.checked);
    helpers.setValue(e.target.checked);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if ((e.key === "Enter" || e.key === "  ") && inputRef.current) {
      inputRef.current.checked = !inputRef.current.checked;
      onChange?.(inputRef.current.checked);
      helpers.setValue(inputRef.current.checked);
    }
  };

  return (
    <ToggleSwitch
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      checked={value || field.value}
      value={field.value}
      name={field.name}
      inputRef={inputRef}
      className={cx("switch", className)}
      label={label}
      labelBold={labelBold}
      hint={hint}
      testId={testId}
    />
  );
};

export default ToggleFormik;
